import { render, staticRenderFns } from "./PrHoldRight.vue?vue&type=template&id=6b89df83&"
import script from "./PrHoldRight.vue?vue&type=script&lang=js&"
export * from "./PrHoldRight.vue?vue&type=script&lang=js&"
import style0 from "./PrHoldRight.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports